import { render } from "./NewReceiverRoom.vue?vue&type=template&id=35485434&scoped=true&ts=true"
import script from "./NewReceiverRoom.vue?vue&type=script&lang=ts"
export * from "./NewReceiverRoom.vue?vue&type=script&lang=ts"

import "./NewReceiverRoom.vue?vue&type=style&index=0&id=35485434&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35485434"]])

export default __exports__